<template>
 <div>
     <div class="row justify-content-center ">
         <div class="col-md-8 pt-3">
             <p class="font-weight-bold pl-3 mb-4 sb-block-title">My Supplements</p>
         </div>
         <div class="col-md-4 pt-3 text-right pr-4">
             <a href="/my-health/supplements/edit" aria-label="My Supplements - Edit" class="color-sky-blue-3" v-if="sups.length > 0">
                 Edit
             </a>
         </div>
     </div>
     <div class="row justify-content-center ">
         <div class="col-md-12">
             <div class="col-md-12 mb-2">
                 <a href="/my-health/supplements/add" class="btn btn-primary btn-sb">Add new supplement</a>
             </div>
             <ul class="list-group mb-3" v-if="sups">
                 <li class="list-group-item border-top-0 border-right-0 border-left-0 ml-0 mr-0" v-for="(s, key) in sups" v-if="view_more || key < 4">
                     <div class="row">
                         <div class="col-md-9 sb-list-fitem-regular">
                             {{ s.sup_sr ? s.sup_srname : s.supplement_data.sud_name }}
                         </div>
                         <div class="col-md-3 text-right sb-list-sitem">
                             <a href="#" class="text-danger" @click="deleteSupById(s)" :aria-label="((s.supplement_data ? s.supplement_data.sud_name : '') + ' - Remove')">
                                 Remove
                             </a>
                         </div>
                     </div>
                 </li>
             </ul>
             <div v-if="sups.length>4" class="text-right mb-3 mr-3">
                 <a href="#" @click.prevent="view_more=!view_more" aria-label="View Less Supplements" v-if="view_more">View Less</a>
                 <a href="#" @click.prevent="view_more=!view_more" aria-label="View More Supplements" v-else>View More</a>
             </div>
         </div>
     </div>
 </div>
</template>

<script>
export default {
    props:['supplements'],
    mounted() {
        this.listSup(true);
    },
    data() {
        return {
            route: '/api/supplements',
            sups: [],
            view_more: false
        }
    },
    methods: {
        listSup(fromProp = false) {
            if (fromProp) {
                this.sups = this.supplements;
            } else {
                this.$http.get(this.route)
                    .then(function (response) {
                        this.sups = response.data;
                    }, (response) => {
                        this._handleErrors(response.data, '#sup-form')
                    })
            }

        },
        deleteSupById(sup) {
            if (!confirm('Do you really want to delete this supplement?'))
                return

            this.$http.delete(this.route + '/' + sup.sup_id, sup)
                .then(function (response) {
                    this.listSup();
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Supplement was deleted!'
                    });
                }, (response) => {
                    this._handleErrors(response.data, '#sup-form')
                })
        },
        _handleErrors: function (items, selector) {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()

            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="' + name + '"]')
                    el.closest('.form-group').addClass('has-error')
                    $('<p class="help-block">' + (items['errors'][error].join(', ')) + '</p>').insertAfter(selector + ' [name="' + name + '"]');
                }
            }
        }
    }

}
</script>
